<template>
    <div>
        <b-card no-body >
            <b-card-body class="mt-pb-0">
               <!--  <h5 id="traffic" class="card-title mb-3 text-left">Change your password</h5>
                <b-alert variant="success" show v-if="passwordSucces">Password changes succesfully.</b-alert>
                <b-alert variant="danger" show v-if="passwordSame">Your new password must be different from your previous password. Please try again.</b-alert>
                <b-alert variant="danger" show v-if="passwordDifferent">Invalid current password. Please try again.</b-alert>
                <b-form  show v-if="!passwordSucces && !passwordDifferent && !passwordSame"  >
                    <b-form-group
                        label-cols-lg="2"
                        id="input-group-1"
                        label="Current Password:"
                        label-for="input-1">
                        <b-row>
                         <b-col sm="4">
                        <b-form-input
                            id="input-1"
                            autocomplete="off"
                            type="password"
                            v-model="oldPassword"
                            required
                            placeholder="Enter current password">
                        </b-form-input>
                         </b-col>
                        </b-row>
                    </b-form-group>
                </b-form>
                <b-form show v-if="!passwordSucces && !passwordDifferent && !passwordSame"  class="mt-2">
                    <b-form-group
                        label-cols-lg="2"
                        id="input-group-2"
                        label="New Password:"
                        label-for="input-2">
                        <b-row>
                         <b-col sm="4">
                        <b-form-input
                            id="input-2"
                            autocomplete="off"
                            type="password"
                            v-model="password"
                            required
                            placeholder="Enter new password">
                        </b-form-input>
                         </b-col>
                         <b-col sm="1">
                        <i class="fa fa-check" v-if="verifyPassword===password && oldPassword!=='' && password!==''" ></i>
                        </b-col>
                        </b-row>
                     </b-form-group>
                </b-form>
                <b-form show v-if="!passwordSucces && !passwordDifferent && !passwordSame"  class="mt-2">
                    <b-form-group
                        label-cols-lg="2"
                        id="input-group-3"
                        label="Verify Password:"
                        label-for="input-3">
                        <b-row>
                         <b-col sm="4">
                        <b-form-input
                            id="input-3"
                            autocomplete="off"
                            type="password"
                            v-model="verifyPassword"
                            required
                            placeholder="Enter new password">
                        </b-form-input>
                         </b-col>
                         <b-col sm="1">
                        <i class="fa fa-check" v-if="verifyPassword===password && oldPassword!=='' && password!==''"></i>
                         </b-col>
                        </b-row>
                    </b-form-group>
                </b-form>
                <b-button  show v-if="!passwordSame && !passwordDifferent && !passwordSucces" @click="updatePassword" type="submit" variant="primary" class="mt-2">Submit</b-button>
                <b-button  show v-if="passwordSucces || passwordDifferent ||passwordSame" @click="newPassword" variant="primary">New Password</b-button>
                <hr>
 -->                <h5 id="traffic" class="card-title mb-3 mt-3 text-left">Upload profile photo</h5>
                 <div class="mb-2 ml-6">Click picture to upload photo
                 </div>
                <label for="fileInput" slot="upload-label" >
                    <img 
                    :src=oldImage
                    height="100px"
                    width="100px"
                    class="img-avatar mb-3"
                    id="my_image"
                    />
                </label>
                <image-uploader
                    :preview="false"
                    class="fileinput"
                    :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                    capture="environment"
                    :debug="0"
                    doNotResize="gif"
                    :autoRotate="true"
                    outputFormat="verbose"
                    @input="setImage">  
                </image-uploader>
                <b-button @click="upload" variant="primary" class="mt-1"> Upload </b-button>
                <hr>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import axios from 'axios'
import JWT from 'jsonwebtoken'
import setProfilePhoto from '../../plugins/setProfilePhoto'
import getProfilePhoto from '../../plugins/getProfilePhoto'
import setPassword from '../../plugins/setPassword'
import getPassword from '../../plugins/getPassword'
export default {
  name: 'Profile',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      userName:'',
      request:false,
      image:'',
      hasImage:false,
      password:'',
      passwordSucces:false,
      passwordSame:false,
      passwordDifferent:false,
      oldImage:'',
      oldPassword:'',
      verifyPassword:'',
    }
  }, 
  methods :{
      /* trigger () {
    	this.$refs.fileInput.input()
    }, */
     /*  newPassword(){
          //@click="document.getElementById('image_uploader').input()"
          this.passwordSucces=false
          this.passwordSame=false
          this.passwordDifferent=false
      },
      async updatePassword(){
        const token = await $cookies.get('user')
        if(token){
        JWT.verify(token, this.$store.state.jwtToken, async (err, decode) => {
            if (err) {
            console.log('Token expired!')
            
            } else {
                let password=this.password
                this.userName=await this.$cookies.get('username')
                await this.$events.listen('SET_USERNAME', username => {
                this.userName=username
                });
                //get password
                let oldPassword=await getPassword(this.userName)
                //check difference from the previous one
                if(this.oldPassword!==oldPassword.data.password){
                    this.passwordDifferent=true
                }
                else if(oldPassword.data.password===password){
                    this.passwordSame=true
                } 
                else if(this.password===this.verifyPassword){
                    //set password
                    await setPassword(this.userName,password)
                    this.passwordSucces=true
                }
                
                this.password=''
                this.oldPassword=''
                this.verifyPassword=''
            }
        })
        }
      }, */
      async upload(){
          await setProfilePhoto(this.userName,this.image)
          await this.$events.fire('PROFILE_PHOTO',this.image)
      },
    async setImage(output) {
        this.image=output.dataUrl
        this.hasImage=true
        this.userName=await this.$cookies.get('username')
        await this.$events.listen('SET_USERNAME', username => {
        this.userName=username
        });
        let username=this.userName
        this.oldImage=this.image
    },
  },
 async created(){
     this.passwordSucces=false,
     this.passwordSame=false,
     this.passwordDifferent=false,
      this.userName=await this.$cookies.get('username')
        await this.$events.listen('SET_USERNAME', username => {
        this.userName=username
        });
     await getProfilePhoto(this.userName).then(im => this.oldImage=im.data.profile_image)
  },
  async mounted(){
      this.userName=await this.$cookies.get('username')
        await this.$events.listen('SET_USERNAME', username => {
        this.userName=username
        });
      await getProfilePhoto(this.userName).then(im => this.oldImage=im.data.profile_image)
  }
  
}
  
</script>
<style  lang="scss">
#fileInput {
  display: none;
}

.fa {
    color: #20a8d8;
}
label {
    margin-bottom: 0rem;
}
/* .form-row > .col, .form-row > [class*="col-"] {
    text-align-last: center;
} */
/* input[type="fileinput" i] {
    height: 1px;
    width: 1px;
    opacity: 0;
} */
/* .fileinput{
     height: 1px;
    width: 1px;
    opacity: 0;
} */

</style>
